import AutoNumeric from 'autonumeric';

export const initMoneyInputs = (root = document, unformatOnSubmit = true) => {
    root.querySelectorAll('[data-money-autonumeric]').forEach((input) => {
        if (AutoNumeric.getAutoNumericElement(input)) {
            return;
        }

        new AutoNumeric(input, {
            digitGroupSeparator: '.',
            decimalCharacter: ',',
            decimalPlaces: 2,
            decimalPlacesShownOnBlur: 2,
            minimumValue: '0',
            unformatOnSubmit,
        });
    });
};

export const moneyInputValue = (input) => {
    const instance = input ? AutoNumeric.getAutoNumericElement(input) : null;

    return instance ? Number(instance.getNumber()) : 0;
};
